 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"management": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"management": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "vue/js/" + ({"AdPageWizard":"AdPageWizard","AdvisorDashboard":"AdvisorDashboard","BulkEditProjectApps":"BulkEditProjectApps","ContentBooks":"ContentBooks","CreateStudio":"CreateStudio","ProjectTemplates~ReportGenerator~WorkerLogs":"ProjectTemplates~ReportGenerator~WorkerLogs","ProjectTemplates":"ProjectTemplates","ProjectTemplate~ReportGenerator":"ProjectTemplate~ReportGenerator","ProjectTemplate":"ProjectTemplate","ProjectWizard":"ProjectWizard","PublisherOrderWizard~ReportGenerator~WorkerLogs":"PublisherOrderWizard~ReportGenerator~WorkerLogs","ReportGenerator":"ReportGenerator","WorkerLogs":"WorkerLogs","PublisherOrderWizard":"PublisherOrderWizard","SeasonAddProjects":"SeasonAddProjects","SubjectOrderReceipt":"SubjectOrderReceipt","UserPageAssignments":"UserPageAssignments","YearbookPersonalizationWizard":"YearbookPersonalizationWizard","YearbookReview":"YearbookReview","jszip":"jszip","jspdf":"jspdf"}[chunkId]||chunkId) + "." + {"AdPageWizard":"b39eb704","AdvisorDashboard":"154a218b","BulkEditProjectApps":"4ce78d6a","ContentBooks":"ffb89d2b","CreateStudio":"408e0010","ProjectTemplates~ReportGenerator~WorkerLogs":"f1a4a46a","ProjectTemplates":"aecfdb7a","ProjectTemplate~ReportGenerator":"ab934865","ProjectTemplate":"f0666fe0","ProjectWizard":"4827e821","PublisherOrderWizard~ReportGenerator~WorkerLogs":"84cfd882","ReportGenerator":"dc7a1738","WorkerLogs":"7f45c66d","PublisherOrderWizard":"29e754e4","SeasonAddProjects":"b13d5caf","SubjectOrderReceipt":"609eef3e","UserPageAssignments":"5ac597aa","YearbookPersonalizationWizard":"bc5d5bbb","YearbookReview":"e26ede3d","jszip":"0acd2284","jspdf":"4ce2a9c3","chunk-2d0c4892":"11033599","chunk-2d0d7fcc":"5b072e58","chunk-6413f742":"21021398"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AdvisorDashboard":1,"BulkEditProjectApps":1,"ContentBooks":1,"CreateStudio":1,"ProjectTemplates~ReportGenerator~WorkerLogs":1,"ProjectTemplates":1,"ProjectTemplate":1,"PublisherOrderWizard~ReportGenerator~WorkerLogs":1,"ReportGenerator":1,"WorkerLogs":1,"PublisherOrderWizard":1,"SeasonAddProjects":1,"SubjectOrderReceipt":1,"UserPageAssignments":1,"YearbookReview":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "vue/css/" + ({"AdPageWizard":"AdPageWizard","AdvisorDashboard":"AdvisorDashboard","BulkEditProjectApps":"BulkEditProjectApps","ContentBooks":"ContentBooks","CreateStudio":"CreateStudio","ProjectTemplates~ReportGenerator~WorkerLogs":"ProjectTemplates~ReportGenerator~WorkerLogs","ProjectTemplates":"ProjectTemplates","ProjectTemplate~ReportGenerator":"ProjectTemplate~ReportGenerator","ProjectTemplate":"ProjectTemplate","ProjectWizard":"ProjectWizard","PublisherOrderWizard~ReportGenerator~WorkerLogs":"PublisherOrderWizard~ReportGenerator~WorkerLogs","ReportGenerator":"ReportGenerator","WorkerLogs":"WorkerLogs","PublisherOrderWizard":"PublisherOrderWizard","SeasonAddProjects":"SeasonAddProjects","SubjectOrderReceipt":"SubjectOrderReceipt","UserPageAssignments":"UserPageAssignments","YearbookPersonalizationWizard":"YearbookPersonalizationWizard","YearbookReview":"YearbookReview","jszip":"jszip","jspdf":"jspdf"}[chunkId]||chunkId) + "." + {"AdPageWizard":"d41d8cd9","AdvisorDashboard":"f19d305e","BulkEditProjectApps":"6559e6cf","ContentBooks":"ea3c4ea9","CreateStudio":"0da12c73","ProjectTemplates~ReportGenerator~WorkerLogs":"28aed1f3","ProjectTemplates":"27e06aae","ProjectTemplate~ReportGenerator":"d41d8cd9","ProjectTemplate":"8986123b","ProjectWizard":"d41d8cd9","PublisherOrderWizard~ReportGenerator~WorkerLogs":"78bca6d2","ReportGenerator":"e0a6fa1c","WorkerLogs":"6eb76759","PublisherOrderWizard":"1309638d","SeasonAddProjects":"5fea104b","SubjectOrderReceipt":"968bb1ea","UserPageAssignments":"cf2e5f59","YearbookPersonalizationWizard":"d41d8cd9","YearbookReview":"e7f4ede2","jszip":"d41d8cd9","jspdf":"d41d8cd9","chunk-2d0c4892":"d41d8cd9","chunk-2d0d7fcc":"d41d8cd9","chunk-6413f742":"d41d8cd9"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([7,"chunk-vendors","chunk-common"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
